import { Action } from 'redux';

import { ClearMixedContentFilters, ContentFilterApplied, FilterContent, SetContentFilterNoRequestContent, UpdateFiltersInBothUrlAndState } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';
import { ContentFilterKeyName } from '../../models/ContentFilters';

export interface ContentFilterAppliedAction extends Action {
  filterType: ContentFilterKeyName;
  value: string;
}

export function mixedContentFilterApplied(filterType: ContentFilterKeyName, value: string): ContentFilterAppliedAction {
  return {
    type: ContentFilterApplied,
    filterType,
    value
  };
}

export const isContentFilterAppliedAction = isActionFactory<ContentFilterAppliedAction>(ContentFilterApplied);

export interface SetContentFilterNoRequestContentAction extends Action {
  filterType: ContentFilterKeyName;
  value: string;
}

export function setContentFilterNoRequestContent(filterType: ContentFilterKeyName, value: string): SetContentFilterNoRequestContentAction {
  return {
    type: SetContentFilterNoRequestContent,
    filterType,
    value
  };
}

export interface FilterContentAction extends Action {
  filterType: ContentFilterKeyName;
  value: string;
}

export function filterMixedContent(filterType: ContentFilterKeyName, value: string): FilterContentAction {
  return {
    type: FilterContent,
    filterType: filterType,
    value,
  };
}

export const isFilterContentAction = isActionFactory<FilterContentAction>(FilterContent);

export interface UpdateFiltersInBothUrlAndStateAction extends Action {
  filterType: ContentFilterKeyName;
  value?: string | boolean;
}

export function updateFiltersInBothUrlAndStateAction(filterType: ContentFilterKeyName, value?: string | boolean): UpdateFiltersInBothUrlAndStateAction {
  return {
    type: UpdateFiltersInBothUrlAndState,
    filterType: filterType,
    value,
  };
}

export interface ClearMixedContentFiltersAction extends Action {}

export function clearMixedContentFilters(): ClearMixedContentFiltersAction {
  return {
    type: ClearMixedContentFilters
  };
}
